import http from "../utils/http";

export const listFiles = () => {
  return http.get("/storage/listFiles");
};

export const uploadFile = ({ file, serviceCode, prefix }) => {
  const data = new FormData();
  data.append("file", file);
  data.append("serviceCode", serviceCode);
  data.append("prefix", prefix);
  return http.post("/storage/uploadFile", data, {
    headers: {
      "content-type": "multipart/form-data",
    },
  });
};
export const uploadFolder = ({ serviceCode, prefix }) => {
  const file = new File([""], "/");
  const data = new FormData();
  data.append("file", file);
  data.append("serviceCode", serviceCode);
  data.append("prefix", prefix);
  return http.post("/storage/uploadFolder", data, {
    headers: {
      "content-type": "multipart/form-data",
    },
  });
};

export const removeFile = (url) => {
  return http.delete("/storage/removeFile", {
    params: {
      url,
    },
  });
};
